import React from "react";
import { Container, Row, Col } from 'react-grid-system';
import 'react-flexr/styles.css'

import Letter from './Letter';

class Eleven extends React.Component {
    render() {
        let gc = this.props.gameController;
        return (
            <>
                <Container fluid style={{ wrap: "nowrap" }}>
                    <Row>
                        <Letter xs={3} parent={gc} nr={1} ref={gc.clearChilds[1]} />
                        <Letter xs={3} parent={gc} nr={2} ref={gc.clearChilds[2]} />
                        <Letter xs={3} parent={gc} nr={3} ref={gc.clearChilds[3]} />
                        <Letter xs={3} parent={gc} nr={4} ref={gc.clearChilds[4]} />
                    </Row>
                    <Row>
                        <Col xs={1} />
                        <Letter xs={3} parent={gc} nr={5} ref={gc.clearChilds[5]} />
                        <Letter xs={3} parent={gc} nr={0} ref={gc.clearChilds[0]} centerletter="true" />
                        <Letter xs={3} parent={gc} nr={6} ref={gc.clearChilds[6]} />
                        <Col xs={1} />
                    </Row>
                    <Row>
                        <Letter xs={3} parent={gc} nr={7} ref={gc.clearChilds[7]} />
                        <Letter xs={3} parent={gc} nr={8} ref={gc.clearChilds[8]} />
                        <Letter xs={3} parent={gc} nr={9} ref={gc.clearChilds[9]} />
                        <Letter xs={3} parent={gc} nr={10} ref={gc.clearChilds[10]} />
                    </Row>
                </Container>
            </>
        );
    }
}

export default Eleven;
